<template lang="html">
  <div class="app-renderer">

    <div class="app-scene" ref="container">
      <!-- WebGL goes here -->
    </div>

    <div class="helpers absolute z-10 right-0 top-0 p-0">
      <!-- <div class="">
        {{hoverID}}
      </div>
      <div class="">
        {{selectID}}
      </div> -->

      <!-- <button class="p-2 bg-white m-2 bg-yellow-300" v-if="!this.scene" @click="initScene">Init Scene</button>
      <button class="p-2 bg-white m-2 bg-red-300" v-if="this.scene" @click="destroyScene">Destroy Scene</button> -->

    </div>
  </div>
</template>

<script>
import Renderer from './Renderer.js'
import {contents} from '@/common/content.js'
import gsap from 'gsap'
export default {

  data () {
    return {
      hoverID: '',
      selectID: '',
      scene: {},
      total: Object.keys(contents).length,
      contents: contents,
    }
  },

  mounted() {
    // vue hook on component mount
    this.initScene()
    this.testMovements()
  },

  beforeDestroy() {
    // vue hook on component destroy
    this.destroyScene()
  },

  computed: {
    stage () {
      return this.$store.state.stage
    },
    scrollProgress () {
      return this.$store.state.scrollProgress
    },
    sceneProgress () {
      return this.$store.state.sceneProgress
    },
    sceneDisplayMode () {
      return this.$store.state.sceneDisplayMode
    },
  },

  watch: {
    '$route' (newVal, oldVal) {
      this.onRouteChange(newVal)
    },
    'stage' (newVal, oldVal) {
      this.onStateStageChange(newVal)
    },
    'scrollProgress' (newVal, oldVal) {
      this.onScrollProgressChange(newVal)
    },
    'sceneProgress' (newVal, oldVal) {
      this.onSceneProgressChange(newVal)
    },
    'sceneDisplayMode' (newVal, oldVal) {
      this.onSceneDisplayModeChange(newVal)
    },
  },

  methods: {
    initScene () {

      this.$store.commit('setStage', { stage: 'LOADING' })

      this.scene = Renderer({
        rootEl: this.$refs.container,
        onHover: this.onItemHover,
        onSelect: this.onItemSelect,
        onLoadComplete: this.onLoadComplete,
        onLoadProgress: this.onLoadProgress,
        hotspots: this.contents
      })

      this.onRouteChange ()
    },
    destroyScene () {
      if (this.scene && this.scene.destroy) {
        this.scene.destroy()
        this.scene=null
      }
    },

    onLoadComplete () {
      // console.log('on loaded')
      this.$store.commit('setStage', { stage: 'LOADED' })
    },

    onLoadProgress (progress) {
      // console.log('on progress', progress)
      this.$store.commit('setLoadingProgress', { progress: progress })
      // this.$store.commit('setStage', { stage: 'LOADED' })
    },

    onItemHover (target) {
      // console.log('vue component onItemHover', target)
    },
    onItemSelect (target) {
      // console.log('vue component onItemSelect', target)
      // if (target&&target.userData&&target.userData.building) {
      //   this.$router.push({ query: { building: target.userData.building }})
      // } else {
      //   this.$router.push({ query: { building: null }})
      // }
    },
    onRouteChange () {
      // let buildingId = this.$route.query.building
      // if (this.scene) {
      //   this.scene.triggerUpdate({id: buildingId})
      // }
    },
    onStateStageChange (newStage) {
      if (newStage=='ENTERED') {
        if (this.scene) {
          this.onScrollProgressChange(0)
          // DISPLAY WIREFRAME only when entered
          // if (window && window.innerWidth > 768) {
            // this.scene.updateDisplayConfig({wireframe: true})
          // }
        }
      }
    },
    onSceneDisplayModeChange (newDisplayMode) {
      if (this.scene) {
        if (newDisplayMode != 1) {
          newDisplayMode = 2
        } else {
          newDisplayMode = 1
        }
        this.scene.updateDisplayConfig({displayMode: newDisplayMode})
      }
    },
    onScrollProgressChange (newVal) {
      // this.select(newVal)
      let contentId = newVal
      let activeContent = this.contents[contentId]

      console.log('renderer onScrollProgressChange:', newVal, activeContent)

      if (newVal>=0&&activeContent&&activeContent.id>=0) {
        this.sceneFocusAtHotspot(activeContent.id)
      }
    },

    sceneFocusAtHotspot(id) {
      this.scene.updateCameraTarget({
        hotspot: id
      })
    },

    onSceneProgressChange (newVal) {

    },

    testMovements () {
      /*
      updateOrbitControls ( option ) {
        option.target.x
        option.target.y
        option.target.z
      }

      updateScene ( option ) {
        option.rotation.x
        option.rotation.y
        option.rotation.z
      }

      updateCamera ( option ) {
        option.position.x
        option.position.y
        option.position.z
      }*/

      // let config = {
      //   x: 0
      // }
      // let configTo = {
      //   x: 0
      // }
      // gsap.to(config, {
      //   x: configTo.x
      //   duration: 5,
      //   onUpdate: () => {
      //     config.x
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
// .app-renderer {
//   @apply fixed inset-0 pl-96
// }
.app-scene {
  @apply w-full h-full bg-gray-100
}
</style>
